// extracted by mini-css-extract-plugin
export var $animation_name = "OutOfStockForm-module--$animation_name--54745";
export var EmailInput = "OutOfStockForm-module--EmailInput--5fcbd";
export var checkBoxContainer = "OutOfStockForm-module--checkBoxContainer--10fa2";
export var col1 = "OutOfStockForm-module--col1--bc1a9";
export var col2 = "OutOfStockForm-module--col2--9ca17";
export var outOfStockForm = "OutOfStockForm-module--outOfStockForm--8d3c9";
export var submissionError = "OutOfStockForm-module--submissionError--aa2ba";